import React, { useState, useEffect } from "react";
import contactImg from "../assest/images/contact-us/cloud.webp";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Loader from "../component/loader.jsx";

function Privacy_Policy() {
  const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);

  const { pathname } = useLocation();

  // This handles the scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Line 24 was here - REMOVED

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Ladakh MotoDrive</title>

        <meta
          name="description"
          content="Read the privacy policy of Ladakh MotoDrive to understand how we collect, use and protect your personal information."
        />

        <link
          rel="canonical"
          href="https://ladakhmotodrive.com/privacy-policy"
        />
        {/* Open Graph */}
        <meta property="og:title" content="Privacy Policy | Ladakh MotoDrive" />
        <meta
          property="og:description"
          content="Read the privacy policy of Ladakh MotoDrive to understand how we collect, use and protect your personal information."
        />
        <meta
          property="og:url"
          content="https://ladakhmotodrive.com/privacy-policy"
        />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Privacy Policy | Ladakh MotoDrive"
        />
        <meta
          name="twitter:description"
          content="Read the privacy policy of Ladakh MotoDrive to understand how we collect, use and protect your personal information."
        />
      </Helmet>
      <div className="container-fulid">
        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg} alt="cloud" />
          </div>
        </div>
        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title">Privacy Policy</h3>
          </div>
        </div>
      </div>

      <div className="container py-5">
        <div className="privacy-wrapper">
          <div className="container">
            <div className="privacy-card">
              <h1 className="privacy-title">Privacy Policy</h1>

              <p>
                At <strong>Ladakh Traveler</strong>, we respect your privacy and
                are committed to protecting your personal information when you
                use our bike rental, car rental, and tour services in Ladakh.
              </p>

              <h4>1. Information We Collect</h4>
              <p>We may collect the following information:</p>
              <ul>
                <li>Name, email address, and phone number</li>
                <li>Travel dates and trip preferences</li>
                <li>Identity documents required for bike or car rentals</li>
                <li>Booking and payment information</li>
              </ul>

              <h4>2. How We Use Your Information</h4>
              <ul>
                <li>To process bike and car rental bookings</li>
                <li>To manage Ladakh tour packages</li>
                <li>To communicate booking confirmations</li>
                <li>To improve our services and website</li>
              </ul>

              <h4>3. Data Security</h4>
              <p>
                We take appropriate security measures to protect your personal
                data from unauthorized access or misuse.
              </p>

              <h4>4. Cookies</h4>
              <p>
                Our website may use cookies to enhance your browsing experience
                and analyze website traffic.
              </p>

              <h4>5. Third-Party Links</h4>
              <p>
                Our website may contain links to third-party websites. We are
                not responsible for their privacy practices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy_Policy;
